<div *ngIf="productionData" class="production-totals clearfix mb-2">
   <div class="total amount text-center">
      <div class="label">{{'order.planned'|translate}}</div>
      <div class="value">{{productionData.totalAmount}} m<sup>3</sup></div>
   </div>
   <div class="total delivered text-center">
      <div class="label">{{'order.delivered'|translate}}</div>
      <div class="value">{{productionData.totalDelivered}} m<sup>3</sup></div>
   </div>
</div>
<table *ngIf="productionData" class="table table-xs table-borderless production">
   <thead>
   <tr>
      <th class="plant">{{'company.plant'|translate}}</th>
      <th class="amount text-right">{{'order.planned'|translate}}</th>
      <th class="delivered text-right">{{'order.delivered'|translate}}</th>
      <th></th>
   </tr>
   </thead>
   <tbody>
   <tr *ngFor="let plantData of productionData.plants">
      <td>{{plantData.name}}</td>
      <td class="text-right">{{plantData.amount}} m<sup>3</sup></td>
      <td class="text-right">{{plantData.delivered}} m<sup>3</sup></td>
      <td><ngb-progressbar [type]="'success'" [showValue]="true"  [max]="plantData.amount" [value]="plantData.delivered"></ngb-progressbar></td>
   </tr>
   </tbody>
</table>
